import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@ipc/ipc-components';
import PropTypes from 'prop-types';

class ExceptionalRouteLeadingCountTypeDeleteDialog extends Component {
  constructor(props) {
    super(props);
    this.confirmEdit = this.confirmEdit.bind(this);
  }

  confirmEdit() {
    this.handleClose();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Are you sure you want to delete?</DialogTitle>
        <div className="after-box">
          <Button className="primary-button" style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button className="primary-button-false" style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }} onClick={this.props.onConfirm}>Confirm</Button>
        </div>
      </Dialog>
    );
  }
}

ExceptionalRouteLeadingCountTypeDeleteDialog.propTypes = {
  onConfirm: PropTypes.func,
  closeDialog: PropTypes.func,
  openDialog: PropTypes.func,
};

export default ExceptionalRouteLeadingCountTypeDeleteDialog;
